Ext.define('SA.view.sidebar.data.DataSearchConditions', {
    alias: 'widget.data-search-conditions',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-data-search-conditions',

    conditionsTpl: [
        '<tpl for=".">',
            '<span aria-label="remove condition" class="sa-data-search-condition" data-type="{type}" data-facet="{facet:htmlEncode}" data-value="{value:htmlEncode}">',
                '<button class="sa-data-search-condition-remove-wrap">',
                    '<svg aria-hidden="true" class="sa-data-search-condition-remove"><use href="#sa-icon-close"></use></svg>',
                '</button>',
                '<span class="sa-data-search-condition-label">{label:htmlEncode}</span>',
            '</span>',
        '</tpl>'
    ],

    items: [
        {
            xtype: 'component',
            autoEl: 'span',
            cls: 'sa-data-search-conditions-total',
            itemId: 'totalLabel',
            tpl: '{total} results for'
        }, {
            xtype: 'component',
            autoEl: 'span',
            cls: 'sa-data-search-conditions-conditions',
            itemId: 'conditionsList'
        }, {
            xtype: 'data-search-conditions-overflow-menu-button',
            itemId: 'overflowMenuBtn'
        }
    ],

    initComponent() {
        var conditionsTpl = this.conditionsTpl.join('');

        this.callParent();

        this.totalLabel = this.down('#totalLabel');
        this.conditionsList = this.down('#conditionsList');
        this.overflowMenuBtn = this.down('#overflowMenuBtn');

        this.conditionsList.tpl = conditionsTpl;
        this.overflowMenuBtn.setConditionsTpl(conditionsTpl);
    },

    getRangeConditionLabel([min, max], format = '%s') {
        var toString = value => value != null ? SA.formatValue(value, format) : value;

        max = toString(max);

        if (max) {
            min = min || 0;
        }

        min = toString(min);

        if (!min) {
            return null;
        }

        if (max) {
            return `${min}-${max}`;
        }

        return `${min} and up`;
    },

    getTplData({total, country, text, filterText, facets, ageRange, incomeRange}) {
        var Facets = SA.data.AttributeFacets,
            conditions = [],
            add = condition => conditions.push(condition),
            datasets = facets.dataset_series,
            countryModel = SA.model.Country.get(country),
            vendors = countryModel.getVendors();

        ageRange = this.getRangeConditionLabel(ageRange);
        incomeRange = this.getRangeConditionLabel(incomeRange, '$%d');

        delete facets.dataset_series;

        if (text) {
            conditions.push({type: 'text', label: `“${text}”`});
        }

        Object.entries(facets).forEach(([facet, value]) => {
            var facetName = Facets.getName(facet),
                groupName = Facets.getGroup(facet).name;

            if (Facets.isCategory(facet)) {
                add({facet, label: facetName});
            }
            else if (facet === 'year') {
                add({type: 'year', label: `Year = ${value}`});
            }
            else if (Array.isArray(value)) {
                value.forEach(value => add({facet, value, label: `${facetName} = ${value}`}));
            }
            else {
                add({facet, label: `${groupName} = ${facetName}`});
            }
        });

        if (incomeRange) {
            add({type: 'incomeRange', label: `Income ${incomeRange}`});
        }

        if (ageRange) {
            add({type: 'ageRange', label: `Age ${ageRange}`});
        }

        if (datasets) {
            vendors.forEach(vendor => {
                var vendorDatasets = countryModel.getDatasetIdsForVendor(vendor),
                    allVendorDatasetsSelected = vendorDatasets.every(vendorDataset => datasets.includes(vendorDataset));

                if (allVendorDatasetsSelected) {
                    add({type: 'vendor', value: vendor, label: `Vendor = ${vendor}`});
                }
                else {
                    vendorDatasets.filter(dataset => datasets.includes(dataset)).forEach(dataset => {
                        var datasetName = SA.data.Vendors.getDatasetModel(dataset).getName();

                        add({facet: 'dataset_series', value: dataset, label: `Dataset = ${datasetName}`});
                    });
                }
            });
        }

        if (filterText) {
            add({type: 'filterText', label: `“${filterText}”`});
        }

        return {total, conditions};
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClickConditionRemoveBtn, this, {delegate: '.sa-data-search-condition-remove-wrap'});

        this.overflowMenuBtn.on('click:removeCondition', this.onClickConditionRemoveBtn, this);

        this.mon(SA.Viewport, 'resize', this.refresh, this);
    },

    onClickConditionRemoveBtn(ev) {
        var getAttr = attr => ev.getTarget('.sa-data-search-condition').getAttribute(attr),
            type = getAttr('data-type'),
            facet = getAttr('data-facet'),
            value = getAttr('data-value') || 'true';

        this.fireEvent('click:conditionRemoveBtn', type, facet, value);
    },

    refresh() {
        var el = this.el,
            data = this.data,
            conditions = data.conditions,
            conditionCount = conditions.length,
            totalLabel = this.totalLabel,
            list = this.conditionsList,
            button = this.overflowMenuBtn,
            visibleConditionEls;

        totalLabel.update(data);
        list.update(conditions);

        button.setVisible(false);

        visibleConditionEls = el.query('.sa-data-search-condition');

        if (hasMoreThanTwoRows()) {
            button.setVisible(true);

            do {
                Ext.removeNode(visibleConditionEls.pop());
                refreshButtonText();
            } while (hasMoreThanTwoRows());
        }

        button.setConditions(conditions.slice(visibleConditionEls.length));

        function hasMoreThanTwoRows() {
            var offsetTops = visibleConditionEls.map(el => el.offsetTop);

            if (button.isVisible()) {
                offsetTops.push(button.el.dom.offsetTop);
            }

            return Ext.Array.unique(offsetTops).length > 2;
        }

        function refreshButtonText() {
            var visibleCount = visibleConditionEls.length,
                overflowCount = conditionCount - visibleCount,
                buttonText = visibleCount === 0 ? (`${overflowCount} conditions`) : (`+${overflowCount} more`);

            button.setText(buttonText);
        }
    },

    setData(data) {
        this.data = this.getTplData(data);

        this.refresh();
    }
});

